import script from "./MultiColorFission.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiColorFission.vue?vue&type=script&setup=true&lang=js"

import "./MultiColorFission.vue?vue&type=style&index=0&id=7a85f3c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a85f3c6"]])

export default __exports__